export interface ChartInput {
  history: number[];
  forecast?: { value: number; low: number; high: number }[];
}

export interface ChartLayout {
  history: [number, number][];
  /** Prognoz chizig'i oxirgi haqiqiy nuqtadan boshlanadi (uzilishsiz). */
  forecast: [number, number][];
  /** Ishonch oralig'i ko'pburchagi: avval yuqori chegara, keyin pastki chegara teskari tartibda. */
  band: [number, number][];
  ticks: { y: number; value: number }[];
  max: number;
}

export interface Box {
  width: number;
  height: number;
  left: number;
  right: number;
  top: number;
  bottom: number;
}

/** "Chiroyli" yuqori chegara: 1, 2, 5 × 10^n. */
export function niceMax(v: number): number {
  if (!(v > 0)) return 1;
  const exp = Math.pow(10, Math.floor(Math.log10(v)));
  const f = v / exp;
  return (f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10) * exp;
}

export function layoutChart({ history, forecast = [] }: ChartInput, box: Box): ChartLayout {
  const total = history.length + forecast.length;
  const max = niceMax(Math.max(0, ...history, ...forecast.map((f) => f.high)));
  const w = box.width - box.left - box.right;
  const h = box.height - box.top - box.bottom;
  const px = (i: number) => box.left + (total <= 1 ? w / 2 : (i / (total - 1)) * w);
  const py = (v: number) => box.top + h - (v / max) * h;
  const hist = history.map((v, i) => [px(i), py(v)] as [number, number]);
  const base = history.length - 1;
  const fc = forecast.map((f, i) => [px(base + 1 + i), py(f.value)] as [number, number]);
  const up = forecast.map((f, i) => [px(base + 1 + i), py(f.high)] as [number, number]);
  const down = forecast.map((f, i) => [px(base + 1 + i), py(f.low)] as [number, number]);
  const anchor = hist.length ? [hist[hist.length - 1]!] : [];
  const band = forecast.length ? [...anchor, ...up, ...down.reverse(), ...anchor] : [];
  const ticks = [0, 1, 2, 3, 4].map((k) => ({ value: (max * k) / 4, y: py((max * k) / 4) }));
  return { history: hist, forecast: forecast.length ? [...anchor, ...fc] : [], band, ticks, max };
}

/** `1 250 000` -> `1,3 mln`; `12 400` -> `12,4 ming`: o'q yozuvlari uchun qisqa ko'rinish. */
export function compact(n: number): string {
  const a = Math.abs(n);
  if (a >= 1_000_000) return `${trim(n / 1_000_000)} mln`;
  if (a >= 10_000) return `${trim(n / 1000)} ming`;
  return trim(n);
}

function trim(n: number): string {
  return String(Math.round(n * 10) / 10).replace(".", ",");
}
